import React, { useState, useContext } from "react";
import { Card, Form, Input, Button, Typography } from "antd";
import {
    EnvironmentOutlined,
    LinkOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const { Text } = Typography;

// Fix default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
    iconUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
    shadowUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

const center = [13.0827, 80.2707];

export default function AddVenue() {
    const { backUrl, authData } = useContext(AuthContext);
    const [form] = Form.useForm();
    const [markerPosition, setMarkerPosition] = useState(null);

    function ClickHandler() {
        useMapEvents({
            click(e) {
                const { lat, lng } = e.latlng;
                setMarkerPosition([lat, lng]);
                const mapLink = `https://www.google.com/maps?q=${lat},${lng}`;
                form.setFieldsValue({
                    map_location_link: mapLink,
                });
            },
        });
        return null;
    }

    const handleSubmit = async (values) => {
        try {
            await axios.post(`${backUrl}/api/emp/venues/`, values, {
                headers: { Authorization: `Bearer ${authData?.access}` },
            });
            toast.success("Venue added successfully!", {
                position: "top-center",
                autoClose: 2000,
            });
            form.resetFields();
            setMarkerPosition(null);
        } catch (err) {
            toast.error("Failed to add venue!", {
                position: "top-center",
                autoClose: 3000,
            });
            console.error(err);
        }
    };

    return (
        <div
            style={{
                width: "100vw",
                height: "100vh",
                position: "relative",
                overflow: "hidden",
            }}
        >
            <ToastContainer />
            <MapContainer
                center={center}
                zoom={12}
                style={{ width: "100%", height: "100%" }}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution="&copy; OpenStreetMap contributors"
                />
                <ClickHandler />
                {markerPosition && (
                    <Marker
                        position={markerPosition}
                        draggable={true}
                        eventHandlers={{
                            dragend: (e) => {
                                const { lat, lng } = e.target.getLatLng();
                                setMarkerPosition([lat, lng]);
                                const mapLink = `https://www.google.com/maps?q=${lat},${lng}`;
                                form.setFieldsValue({
                                    map_location_link: mapLink,
                                });
                            },
                        }}
                    />
                )}
            </MapContainer>

            <Card
                style={{
                    position: "absolute",
                    top: 20,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "90%",
                    maxWidth: 400,
                    borderRadius: 12,
                    boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
                    zIndex: 1000,
                    backgroundColor: "rgba(255,255,255,0.9)",
                    backdropFilter: "blur(10px)",
                    padding: "10px 16px",
                }}
                bodyStyle={{ padding: "10px 0 0 0" }}
            >
                <center>
                    <Text
                        style={{
                            color: "#0e497b",
                            fontWeight: "bold",
                            textTransform: "uppercase",
                            fontSize: "clamp(14px, 2vw, 18px)",
                        }}
                    >
                        <EnvironmentOutlined style={{ marginRight: 8 }} />
                        Add Venue for Interview
                    </Text>
                </center>

                <Form
                    form={form}
                    layout="vertical"
                    style={{ marginTop: 15 }}
                    onFinish={handleSubmit}
                >
                    <Form.Item
                        label="Venue"
                        name="venue"
                        rules={[
                            { required: true, message: "Please enter a venue name" },
                        ]}
                    >
                        <Input
                            prefix={<EnvironmentOutlined />}
                            placeholder="Enter venue name"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Map Location Link"
                        name="map_location_link"
                        rules={[
                            { required: true, message: "Click on map to select location" },
                        ]}
                    >
                        <Input
                            prefix={<LinkOutlined />}
                            placeholder="Click on map to select location"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            style={{
                                backgroundColor: "#0e497b",
                                borderRadius: 8,
                                fontWeight: "bold",
                                fontSize: "clamp(14px, 2vw, 16px)",
                                height: 45,
                            }}
                            icon={<PlusOutlined />}
                        >
                            Add Venue
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
}
